// @mui
import { Box, Button, Typography, useTheme } from '@mui/material';
// components
import { CenteredContent } from 'theme/elements/Content';
import { useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';
import { Stack } from '@mui/system';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { CustomAppBar } from 'theme/layouts/navbar';

export const PageNotFound = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const t = useAppSelector(selectTranslations);
	return (
		<Box sx={{ height: '100vh', background: theme.palette.root.graybg }}>
			<CustomAppBar open={false} mobile={true}>
				<img src="/images/brand-logo-color.webp" alt="open" />
			</CustomAppBar>
			<CenteredContent>
				<Stack spacing={5} sx={{ textAlign: 'center' }}>
					<Box
						sx={{
							position: 'relative',
							'&:before': {
								fontSize: theme.typography.pageTitle,
								top: 0,
								bottom: 0,
								right: 0,
								left: 0,
								position: 'absolute',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-around',
							},
							'& img': {
								[theme.breakpoints.down('sm')]: { width: '90%' },
							},
						}}
					>
						<img src={'/icons/404.svg'} />
					</Box>
					<Typography sx={{ fontFamily: theme.typography.body3 }}>
						{t('error.code.404.description')}
					</Typography>
					<Button
						variant="contained"
						onClick={() => {
							navigate('/');
						}}
					>
						{t('error.code.404.button')}
					</Button>
				</Stack>
			</CenteredContent>
		</Box>
	);
};
